export default __webpack_public_path__ + "static/media/mw.e92243c6.svg";